import React from 'react'

import mdParser from '@/utils/mdParser'
import { MarkdownStyle } from '@/utils/styles'

type MarkdownPropType = {
  content: string
  className?: string
  style?: React.CSSProperties
}

const defaultRender = mdParser.renderer.rules.image

const Markdown: React.FC<MarkdownPropType> = ({ content, className, style }) => {
  const renderHTML = (text: string) => {
    mdParser.renderer.rules.image = (tokens, idx, options, env, s) => {
      return defaultRender ? defaultRender(tokens, idx, options, env, s) : ''
    }
    return mdParser.render(text)
  }
  if (!content) {
    return <div />
  }

  return (
    <div className={className} style={style}>
      <MarkdownStyle id="markdownStyle">
        <span dangerouslySetInnerHTML={{ __html: renderHTML(content ?? '') }} />
      </MarkdownStyle>
    </div>
  )
}

export default Markdown
